import { z } from "zod";
import { roleSchema } from "./role";

export const addCompanyUserSchema = z.object({
  userId: z.string(),
  departmentId: z.string().optional(),
  role: roleSchema,
});
export type AddCompanyUser = z.infer<typeof addCompanyUserSchema>;

export const removeCompanyUserSchema = z.object({
  departmentId: z.string().optional(),
});
export type RemoveCompanyUser = z.infer<typeof removeCompanyUserSchema>;

export const updateCompanyUserSchema = z.object({
  role: roleSchema.nullable(),
  departmentId: z.string().optional(),
});
export type UpdateCompanyUser = z.infer<typeof updateCompanyUserSchema>;
